import { getFirstSlotElement } from './slot';
export const getRect = el => {
  const {
    x,
    y,
    width,
    height
  } = el.getBoundingClientRect();
  return {
    x,
    y,
    width,
    height
  };
};
export const rectOverlap = (targetRect, contentRect) => {
  return targetRect.x < contentRect.x + contentRect.width && targetRect.x + targetRect.width > contentRect.x && targetRect.y < contentRect.y + contentRect.height && targetRect.y + targetRect.height > contentRect.y;
};
export const getTargetRect = slot => {
  const item = getFirstSlotElement(slot, true);
  if (item === null) {
    return null;
  }
  if (Reflect.has(item, 'footprintRect')) {
    return item.footprintRect;
  }
  return getRect(item);
};